import React, { Component } from 'react'

export default class BoxSearch extends Component {
	render() {
		return (
            <div className="searchbar">
                <div>
                    <input className="form-control input-sm" type="search" placeholder="&#xf002; Busqueda por nombre" onChange={e => this.props.onChange(e.target.value) } />
                </div>
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Layout/BoxSearch.jsx